"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsPickerOld = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _CounterPluralize = _interopRequireDefault(require("../CounterPluralize"));
var _SearcherDropdown = _interopRequireDefault(require("../SearcherDropdown"));
var _SearcherFlexBadge = _interopRequireDefault(require("../SearcherFlexBadge"));
var _pluralizeUtils = require("../../utils/pluralizeUtils");
var _excluded = ["flex", "minValue", "maxValue", "onChange", "onChangeFlex", "showFlexNights", "value"];
var Input = _SearcherDropdown["default"].Input;
var StyledInput = _styledComponents["default"].div.withConfig({
  displayName: "NightsPickerOld__StyledInput",
  componentId: "sc-1f1yuts-0"
})(["display:flex;align-items:baseline;"]);
var StyledSearcherFlexBadge = (0, _styledComponents["default"])(_SearcherFlexBadge["default"]).withConfig({
  displayName: "NightsPickerOld__StyledSearcherFlexBadge",
  componentId: "sc-1f1yuts-1"
})(["margin-left:10px;"]);
/**
 * @deprecated
 */
var NightsPickerOld = exports.NightsPickerOld = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$flex = _ref.flex,
    flex = _ref$flex === void 0 ? false : _ref$flex,
    _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 2 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 30 : _ref$maxValue,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function (val) {
      return undefined;
    } : _ref$onChange,
    _ref$onChangeFlex = _ref.onChangeFlex,
    onChangeFlex = _ref$onChangeFlex === void 0 ? Function.prototype : _ref$onChangeFlex,
    _ref$showFlexNights = _ref.showFlexNights,
    showFlexNights = _ref$showFlexNights === void 0 ? true : _ref$showFlexNights,
    value = _ref.value,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SearcherDropdown["default"], (0, _extends2["default"])({
    labelContent: /*#__PURE__*/_react["default"].createElement(StyledInput, null, "".concat(value, " ").concat((0, _pluralizeUtils.pluralizeNights)(value)), flex && /*#__PURE__*/_react["default"].createElement(StyledSearcherFlexBadge, null))
  }, props), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, {
    value: value,
    text: (0, _pluralizeUtils.pluralizeNights)(value),
    onChange: onChange,
    minValue: minValue,
    maxValue: maxValue
  }), showFlexNights && /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    checked: flex,
    onChange: onChangeFlex
  }, "\xB12 ", _localization.i18n.t('hotel.offer.night_one'))));
});
NightsPickerOld.displayName = 'NightsPicker';
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "NightsPickerOld__StyledCheckbox",
  componentId: "sc-1f1yuts-2"
})(["height:50px;display:flex;justify-content:center;align-items:center;user-select:none;outline:0;box-shadow:inset 0 1px 0 #c2c5cc;input{outline:0;}"]);
var StyledCounterPluralize = (0, _styledComponents["default"])(_CounterPluralize["default"]).withConfig({
  displayName: "NightsPickerOld__StyledCounterPluralize",
  componentId: "sc-1f1yuts-3"
})(["height:50px;padding:0 10px;"]);
NightsPickerOld.Input = Input;